import { ATTENDANCE_POLICIES, normalizeAttendancePolicy } from "./attendanceCopy";

function fmtMin(total) {
  const n = Math.max(0, Number(total) || 0);
  const h = Math.floor(n / 60);
  const m = n % 60;
  if (h <= 0) return `${m} min`;
  if (m === 0) return `${h}h`;
  return `${h}h${String(m).padStart(2, "0")}m`;
}

function fmtClock(hm) {
  return String(hm || "").slice(0, 5) || "—";
}

function bankLabel(minutes) {
  const n = Number(minutes) || 0;
  if (n === 0) return "zerado";
  if (n > 0) return `${fmtMin(n)} a crédito`;
  return `${fmtMin(Math.abs(n))} a débito`;
}

export function jornadaAlertsCopy(schedule) {
  const policy = normalizeAttendancePolicy(schedule?.attendancePolicy || schedule?.policy);
  const key = policy?.policy;
  const isInternship = key === ATTENDANCE_POLICIES.ESTAGIO;
  const isOutro = key === ATTENDANCE_POLICIES.OUTRO_CLOCK;
  const legalClt = Boolean(schedule?.legalClt);
  const start = fmtClock(schedule?.today?.start);
  const end = fmtClock(schedule?.today?.end);
  const breakStart = fmtClock(schedule?.today?.breakStart);
  const breakEnd = fmtClock(schedule?.today?.breakEnd);
  const breakMin = schedule?.today?.breakMinutes || schedule?.breakDue?.minutes || 0;
  const lateMin = schedule?.late?.minutes || 0;
  const overMin = schedule?.exitDue?.minutesOver || 0;
  const bank = schedule?.hoursBank;
  const dest = schedule?.compensation?.overtimeDestination;
  const deficitDest = schedule?.compensation?.deficitDestination;
  const overtimePct = schedule?.compensation?.overtimePercent || 50;
  const maxHe = schedule?.compensation?.maxDailyOvertimeMinutes || 120;
  const months = bank?.compensateMonths || 6;

  const overtimeWhere =
    dest === "paid"
      ? `hora extra remunerada com adicional de ${overtimePct}%`
      : `crédito no banco de horas (compensar em até ${months} meses)`;
  const lateWhere =
    deficitDest === "payroll_discount"
      ? "desconto em folha do tempo não trabalhado"
      : "débito no banco de horas";

  if (isInternship) {
    return {
      lateTitle: "Você entrou depois do horário de estágio",
      lateBody: `O horário de entrada hoje é ${start}. Você chegou ${fmtMin(lateMin)} depois do previsto. Entre no horário correto nos próximos dias — o registro comprova o teto da Lei 11.788/2008 e não gera hora extra da CLT.`,
      lateAck: "Entendi, vou observar o horário",
      lateJustify: "Justificar o atraso",
      exitTitle: "Horário de estágio encerrado",
      exitBody: `O horário de saída hoje é ${end}. Encerrar agora evita estouro do teto diário/semanal do estágio.`,
      exitStayHint:
        "Se precisar continuar, justifique. Tempo além do teto não é hora extra e pode descaracterizar o estágio.",
      stayTitle: "Justificar permanência no estágio",
      stayBody: "Descreva por que o horário de estágio precisa continuar agora.",
      staySubmit: "Registrar justificativa",
      breakTitle: "Horário de intervalo do estágio",
      breakBody: `O intervalo hoje é das ${breakStart} às ${breakEnd} (${fmtMin(breakMin)}). Registre o intervalo agora — você continua no escritório em horário de almoço.`,
      breakStayHint: "Sem intervalo registrado, o horário de estágio fica contínuo e pode estourar o teto da Lei 11.788.",
      breakStayTitle: "Justificar permanência no intervalo",
      breakStayBody: "Descreva por que o intervalo de estágio precisa ser adiado agora.",
      breakReturnTitle: "Hora de voltar do intervalo",
      breakReturnBody: `O intervalo termina às ${breakEnd}. Volte do almoço para registrar o retorno.`,
      banner: `Horário de estágio até ${end}${breakStart !== "—" ? ` · intervalo ${breakStart}–${breakEnd}` : ""}`,
    };
  }

  if (isOutro) {
    return {
      lateTitle: "Você entrou depois do horário cadastrado",
      lateBody: `O horário de entrada hoje é ${start}. Você chegou ${fmtMin(lateMin)} depois do previsto. Entre no horário correto — o RH configurou controle para esta modalidade.`,
      lateAck: "Entendi, vou observar o horário",
      lateJustify: "Justificar o atraso",
      exitTitle: "Horário de saída chegou",
      exitBody: `O horário de saída hoje é ${end}. Encerre o expediente ou justifique por que precisa continuar.`,
      exitStayHint: "A permanência sem justificativa continua sendo registrada no horário.",
      stayTitle: "Justificar permanência",
      stayBody: "Descreva o motivo de continuar após o horário cadastrado.",
      staySubmit: "Registrar justificativa",
      breakTitle: "Horário de intervalo",
      breakBody: `O intervalo hoje é das ${breakStart} às ${breakEnd}. Registre o intervalo agora — você continua no escritório em horário de almoço.`,
      breakStayHint: "Sem justificativa, o alerta continua até você registrar o intervalo.",
      breakStayTitle: "Justificar permanência no intervalo",
      breakStayBody: "Descreva por que precisa continuar sem registrar o intervalo.",
      breakReturnTitle: "Hora de voltar do intervalo",
      breakReturnBody: `O intervalo termina às ${breakEnd}. Volte do almoço para registrar o retorno.`,
      banner: `Horário até ${end}${breakStart !== "—" ? ` · intervalo ${breakStart}–${breakEnd}` : ""}`,
    };
  }

  return {
    lateTitle: "Você entrou atrasado no expediente",
    lateBody: `O horário de entrada hoje é ${start}. Você chegou ${fmtMin(lateMin)} depois da tolerância da CLT (art. 58, §1º). Entre no horário correto — atraso pode gerar ${lateWhere}.`,
    lateAck: "Entendi, vou entrar no horário",
    lateJustify: "Justificar o atraso",
    lateJustifyHint:
      "Atraso justificado (trânsito excepcional, consulta, ordem da empresa etc.) não entra como desconto nem débito de banco.",
    exitTitle: "Horário de sair o expediente",
    exitBody: `O expediente de hoje termina às ${end}. Encerre agora para não gerar extra além da jornada. Se precisar continuar, justifique o motivo.`,
    exitStayHint: legalClt
      ? `Permanência vira ${overtimeWhere}. O teto da CLT (art. 59) é ${fmtMin(maxHe)} extras por dia. Sem justificativa, o alerta continua até você sair.`
      : "Encerre o expediente ou justifique a permanência.",
    exitLimit:
      schedule?.exitDue?.overLegalLimit
        ? `Você já passou do teto de ${fmtMin(maxHe)} extras do dia. Encerre o expediente ou alinhe com o RH.`
        : null,
    stayTitle: "Justificar permanência após o expediente",
    stayBody: legalClt
      ? `Descreva por que precisa continuar. O tempo extra entra como ${overtimeWhere}, salvo o RH destinar de outro modo.`
      : "Descreva por que precisa continuar após o horário.",
    stayHoursBank: "Lançar no banco de horas",
    stayPaid: `Pagar como hora extra (+${overtimePct}%)`,
    staySubmit: "Continuar e justificar",
    leaveExit: "Encerrar expediente",
    leaveBreak: "Sair para intervalo",
    breakTitle: "Horário de almoço / intervalo",
    breakBody: `O intervalo de hoje é das ${breakStart} às ${breakEnd} (${fmtMin(breakMin)}). Registre o intervalo agora — você continua no escritório em horário de almoço. A CLT (art. 71) exige intervalo nas jornadas acima de 6 horas.`,
    breakStayHint:
      "Se continuar trabalhando, o intervalo não é registrado. Sem justificativa, o aviso permanece até você registrar o intervalo.",
    breakStayTitle: "Justificar permanência no intervalo",
    breakStayBody: "Descreva por que precisa continuar sem sair para o almoço agora.",
    breakReturnTitle: "Hora de voltar do intervalo",
    breakReturnBody: `O intervalo termina às ${breakEnd}. Volte do almoço para registrar o ponto de retorno.`,
    breakReturnAction: "Voltar do intervalo",
    breakReturnHint: "Se você saiu do escritório, ingresse de novo para registrar o fim do intervalo.",
    banner: `Expediente até ${end}${breakStart !== "—" ? ` · almoço ${breakStart}–${breakEnd}` : ""}`,
    bankLine:
      legalClt && bank?.enabled
        ? `Banco de horas: ${bankLabel(bank.balanceMinutes)} · compensar em ${months} meses`
        : null,
  };
}

export { fmtMin, fmtClock, bankLabel };
